import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import BoardRegular from './board-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BoardRegular {...validProps} />;
}
SvgComponent.iconName = 'boardRegular';

export const BoardRegularIcon = svgIconWrapper(SvgComponent);
